var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid-component"},[_c('div',{staticClass:"__image_container",style:(_vm.styles)},[_vm._t("default"),(_vm.count > 0)?_c('div',{staticClass:"__image_body __quarter __image_count",on:{"click":function($event){return _vm.passData()}}},[_c('p',[_vm._v(_vm._s(_vm.image_excess))])]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }